var link_preview_default = {
  "fontElementMap": "LMqIy",
  "linkPreview": "Pd742",
  "linkPreviewImage": "faKzO",
  "linkPreviewInfo": "ZML3P",
  "linkPreviewTitle": "bjmue",
  "ellipsis": "UxO-l",
  "linkPreviewDescription": "_7YJyQ",
  "linkPreviewUrl": "d6vqN"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
